import React, { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { errorMessage } from '../../../constants/errorMessages'
import { SelectArrow } from '../../SelectArrow'
import { IUserRoles } from '../../../constants/userRoles'

const useStyles = makeStyles((theme: Theme) => ({
  inputContainer: {
    height: 60,
    marginBottom: 5,
    margin: ({ margin }: InputSelectProps) => margin,
    width: ({ width }: InputSelectProps) => width,
    paddingLeft: ({ pl }: InputSelectProps) => pl,
    '& #select-outlined': {
      color: 'rgba(255,255,255,0.6)',
      fontSize: 16,
      backgroundColor: 'inherit',
    },
  },
  label: {
    fontSize: 16,
    color: theme.palette.primary.main,
    opacity: 0.72,
  },
  formControl: {
    width: ({ width }: InputSelectProps) => width,
    // height: 30,
    color: theme.palette.primary.light,
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    '&:hover .MuiInput-underline:before ': {
      borderBottom: `1px solid ${theme.palette.primary.main}`,
    },
    '& .MuiInput-underline:after ': {
      borderBottom: `1px solid ${theme.palette.primary.main}`,
    },
    '& #select-outlined': {
      color: theme.palette.primary.dark,
      fontSize: 14,
    },
  },
  selectField: {
    fontSize: 14,
    fontWeight: 500,
  },
  errorStyle: {
    color: theme.palette.error.main,
  },
}))

interface InputSelectProps {
  enums?: IUserRoles[]
  labelName?: string
  inputName: string
  placeholder?: string
  width: number | string
  margin?: string
  pl?: number | string
  defaultValue?: string
  onBlur?: () => void
}

const selectArr = [
  { id: 1, city: 'Num 1' },
  { id: 2, city: 'Num 2' },
  { id: 3, city: 'Num 3' },
]

export const InputSelect: FC<InputSelectProps> = ({
  enums,
  labelName,
  inputName,
  placeholder,
  width,
  pl,
  margin,
  defaultValue = '',
  onBlur,
}) => {
  const { inputContainer, formControl, selectField, errorStyle } = useStyles({
    width,
    margin,
    pl,
    placeholder,
    inputName,
  })
  const {
    register,
    formState: { errors },
  } = useFormContext()
  const error = errors[inputName]

  return (
    <>
      <Grid container item className={inputContainer} direction={'row'} wrap={'wrap'}>
        {/* {labelName && ( */}
        {/*  <Grid item> */}
        {/*    <InputLabel shrink htmlFor={inputName} className={label}> */}
        {/*      {labelName} */}
        {/*    </InputLabel> */}
        {/*  </Grid> */}
        {/* )} */}
        <Grid item>
          {/* <Controller */}
          {/*  rules={{ required: true }} */}
          {/*  control={control} */}
          {/*  name={inputName} */}
          {/*  render={({ field }) => ( */}
          <FormControl className={formControl} variant={'standard'} size={'small'}>
            <InputLabel id="select">{labelName}</InputLabel>
            <Select
              {...register(inputName)}
              id={inputName}
              IconComponent={SelectArrow}
              className={selectField}
              inputProps={{ 'aria-label': 'Without label' }}
              defaultValue={defaultValue}
              onBlur={onBlur}
            >
              {enums &&
                // eslint-disable-next-line @typescript-eslint/no-shadow
                enums.map((data: IUserRoles) => (
                  <MenuItem key={data.value} value={data.value}>
                    {data.label}
                  </MenuItem>
                ))}
              {!enums &&
                selectArr.map((el) => (
                  <MenuItem key={el.id} value={el.city}>
                    {el.city}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          {/*  )} */}
          {/* /> */}
        </Grid>
        <Grid item>
          {error && (
            <FormHelperText error id="component-error-text" className={errorStyle}>
              {error.message ? error.message : errorMessage.EMPTY_FIELD}
            </FormHelperText>
          )}
        </Grid>
      </Grid>
    </>
  )
}
